import {
    maxLength,
    minLength,
    isRequired
} from '@shared/validators/forms';
import config from '@config';

export default {
    data() {
        return {
            fields: {
                country: {
                    value: null,
                    validate: [
                        isRequired,
                    ],
                },
            }
        };
    },
    created() {
        (this as any).addressFields = {
            city: {
                value: '',
                validate: [
                    isRequired,
                ],
            },
            county: {
                value: null,
                validate: [
                    (this as any).requiredIfPolandCountry,
                ],
            },
            postalCode: {
                value: '',
            },
            address: {
                value: '',
                validate: [
                    isRequired,
                    minLength(5),
                    maxLength(80),
                ],
            },
        };
    },
    methods: {
        requiredIfPolandCountry(value: string) {
            const isPolishNationality = (this as any).fields.nationality.value
                === config.countrySpecific.auth.polishNationality;
            const isPolandCountry = (this as any).fields.nationality.value
                === config.countrySpecific.auth.polishNationality;
            if (isPolishNationality || !isPolandCountry) {
                return false;
            }

            return isRequired(value);
        },
        addFields(fieldsToAdd: any) {
            Object.keys(fieldsToAdd).forEach((key) => {
                (this as any).$set((this as any).fields, key, fieldsToAdd[key]);
            });
        },
        removeFields(fieldsToRemove: any) {
            Object.keys(fieldsToRemove).forEach((key) => {
                (this as any).$delete((this as any).fields, key);
            });
        }
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/poland/app/modules/authentication/mixins/PolandRegisterMixin.ts